import * as THREE from 'three';

/**
 * World axes with arrows in both positive and negative directions (6 arrows).
 */
export class SixAxisHelper extends THREE.Object3D {
  constructor(size = 3000) {
    super();

    const createArrow = (dir, color) => {
      const arrow = new THREE.ArrowHelper(
        dir.clone().normalize(),
        new THREE.Vector3(0, 0, 0),
        size,
        color,
        0,
        0
      );
      this.add(arrow);
    };

    createArrow(new THREE.Vector3(1, 0, 0), 0xff0000);
    createArrow(new THREE.Vector3(-1, 0, 0), 0xaa0000);

    createArrow(new THREE.Vector3(0, 1, 0), 0x00ff00);
    createArrow(new THREE.Vector3(0, -1, 0), 0x00aa00);

    createArrow(new THREE.Vector3(0, 0, 1), 0x0000ff);
    createArrow(new THREE.Vector3(0, 0, -1), 0x0000aa);
  }
}
